import { Typography } from '@ghq-abi/design-system-v2';

import { ACCENT, BACKGROUND, TEXT_COLOR } from '~/shared/constants/badge';
import { BaseBadgeProps } from '~/shared/types/Badges';

export function BaseBadge({ label, variant = 'neutral' }: BaseBadgeProps) {
  return (
    <span
      className="inline-flex items-center gap-1 rounded-[4px] px-2 py-1"
      style={{ color: TEXT_COLOR, backgroundColor: BACKGROUND[variant] }}>
      <span
        aria-hidden
        className="size-2 shrink-0 rounded-md"
        style={{ backgroundColor: ACCENT[variant] }}
      />
      <Typography
        as="span"
        variant="metadata-sm-regular"
        className="text-current !m-0 !p-0 leading-none text-[14px]">
        {label}
      </Typography>
    </span>
  );
}
